<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span>{{ '+SRC_COMMISSIONINGV2.ADD_COMPONENT_HEADER' | translate }}</span>
      <button mat-icon-button (click)="onCancel()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="content__body">
      <div class="content__description-section">
        <div class="description-section__header">
          {{ '+SRC_COMMISSIONINGV2.SELECT_HC_SUBTITLE' | translate }}
        </div>

        <div class="description-section__circuits">
          <mat-radio-group
            *ngIf="allCircuits | ready as circuits"
            class="hc-selection__radio-group"
            [ngModel]="selectedOption"
            (ngModelChange)="onHcOptionSelect($event)"
          >
            <mat-radio-button
              *ngFor="let circuit of circuits | featureValue: featurePropertyKey.enabled"
              color="primary"
              [value]="circuit"
            >
              <span class="radio__name">{{
                installationService.getCircuitName(circuit) | async
              }}</span>
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <button
      gtm="onPreviousStep"
      gtmAction="cancel"
      gtmCategory="assignHcModal"
      mat-stroked-button
      color="primary"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      gtm="onNextStep"
      gtmAction="confirm step"
      gtmCategory="assignHcModal"
      mat-raised-button
      color="primary"
      [disabled]="!selectedOption"
      (click)="onConfirm()"
    >
      {{ 'GENERAL.BUTTON.CONFIRM' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
